import type { SVGProps } from 'react'
const SvgSyQuestion = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fillOpacity={0.24} d="M21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9" />
		<path d="M12 2.4c-5.295 0-9.6 4.305-9.6 9.6s4.305 9.6 9.6 9.6 9.6-4.305 9.6-9.6-4.305-9.6-9.6-9.6m0 1.2c4.646 0 8.4 3.754 8.4 8.4s-3.754 8.4-8.4 8.4-8.4-3.754-8.4-8.4S7.354 3.6 12 3.6" />
		<path d="M12.6 18a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6.6.6 0 0 1 .6-.6.6.6 0 0 1 .6.6" />
		<path d="M12 17.3a.7.7 0 0 0 0 1.4.7.7 0 0 0 0-1.4m0 .2a.499.499 0 1 1 0 1 .499.499 0 1 1 0-1m0-11.1A3.61 3.61 0 0 0 8.4 10h1.2c0-1.333 1.067-2.4 2.4-2.4s2.4 1.067 2.4 2.4v.258c0 .889-.443 1.716-1.183 2.209l-.598.4a2.74 2.74 0 0 0-1.219 2.276V16h1.2v-.857c0-.515.255-.993.683-1.278l.6-.398a3.86 3.86 0 0 0 1.717-3.21V10A3.61 3.61 0 0 0 12 6.4" />
	</svg>
)
export default SvgSyQuestion
